module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.table) ? _c('div', {
    staticClass: "product-table",
    attrs: {
      "id": _vm.table.id
    }
  }, [(_vm.table.title) ? _c('h2', [_vm._v(_vm._s(_vm.table.title))]) : _vm._e(), _vm._v(" "), _c('table', {
    staticClass: "table is-narrow"
  }, [_c('thead'), _vm._v(" "), _c('tbody', _vm._l((_vm.table.config), function(row, rowIndex) {
    return _c('tr', {
      staticClass: "field",
      style: (rowIndex % 2 === 0 ? 'background-color: #F8F8F8' : '')
    }, [(row.decorator !== 'separator') ? [_c('td', {
      staticStyle: {
        "font-weight": "bold"
      },
      domProps: {
        "innerHTML": _vm._s(row.label)
      }
    }), _vm._v(" "), _vm._l((_vm.table.data), function(cell, cellIndex) {
      return _c('tablefield', {
        key: rowIndex + '-' + '-' + cellIndex,
        attrs: {
          "column": row,
          "product": cell,
          "secondary-index": 0,
          "singleLine": true
        }
      })
    })] : [_c('td', {
      staticStyle: {
        "font-weight": "bold",
        "background-color": "#F8F8F8"
      },
      attrs: {
        "colspan": _vm.table.data.length + 1
      },
      domProps: {
        "innerHTML": _vm._s(row.label)
      }
    })]], 2)
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "fineprint table-time"
  }, [_vm._v(_vm._s(_vm.time))])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77f108c0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/table/TableWhitelabel.vue
// module id = 703
// module chunks = 0